import MainNavigation from './MainNavigation'

export default MainNavigation
